import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'getReportParameters'

export default ({ path, rdl }) => (asyncAction(
  name,
  ReportsService.getReportParameters,
  { path, rdl }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/getReportParameters.js